var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMonthlyPlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76 64V12C76 5.37258 70.6274 0 64 0L12 0C5.37258 0 0 5.37258 0 12V64C0 70.6274 5.37258 76 12 76H64C70.6274 76 76 70.6274 76 64Z",
    fill: "#ED8936"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M76 64C76 70.63 70.63 76 64 76H34C34 52.8 52.8 34 76 34V64Z",
    fill: "#FBD38D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M30 0V26C30 28.21 28.21 30 26 30L0 30L0 12C0 5.37 5.37 0 12 0L30 0Z",
    fill: "#FBD38D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonthlyPlan);
export default __webpack_public_path__ + "static/media/MonthlyPlan.c478a96b7ca835c0b3e35a8df57ef8ce.svg";
export { ForwardRef as ReactComponent };